export default __webpack_public_path__ + "static/media/sequo.8e50c2c2.svg";